import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { cx } from 'emotion'
import { themeGet as th } from 'styled-system'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Tooltip, Icon } from 'shared/ui'

const IconWithTooltip = ({
  active,
  className,
  tooltip,
  tooltipPosition,
  ...rest
}) => {
  return (
    <Tooltip position={tooltipPosition} tooltip={tooltip}>
      <Icon className={cx(className, { active })} {...rest} />
    </Tooltip>
  )
}

IconWithTooltip.propTypes = {
  active: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
}

IconWithTooltip.defaultProps = {
  active: false,
  tooltipPosition: 'bottom',
  tooltip: '',
  hoverColor: 'groovy',
}

export default styled(IconWithTooltip)`
  height: 32px;
  padding-top: 4px;
  color: ${props =>
    props.color ? themeVars[props.color] : themeVars.ultraLight};
  position: relative;
  top: 1px;

  // &:hover {
  //   border-radius: 4px;
  //   background-color: ${th('colors.brightSuperDark')};
  // }

  // &.active {
  //   border-radius: 4px;
  //   background-color: ${th('colors.borderGray')};
  // }
`
